import React from 'react';
import { useNavigate } from 'react-router-dom';
import { XCircle } from 'lucide-react';
import Header from './Header';
import './CheckoutCancel.css';

const CheckoutCancel = () => {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen" style={{background: 'linear-gradient(135deg, #1f2937 0%, #111827 50%, #0f172a 100%)'}}>
      <Header />
      
      <main className="checkout-cancel-container">
        <div className="checkout-cancel-card">
          <div className="checkout-cancel-icon">
            <XCircle className="h-16 w-16" style={{color: '#ef4444'}} />
          </div>
          
          <h1 className="checkout-cancel-title">Payment Cancelled</h1>
          
          <p className="checkout-cancel-message">
            Your payment was cancelled. No charges were made to your account.
            You can return to the services page to try again.
          </p>

          <div className="checkout-cancel-actions">
            <button 
              onClick={() => navigate('/pricing')}
              className="checkout-cancel-button"
            >
              Return to Services
            </button>
            <button 
              onClick={() => navigate('/')}
              className="checkout-cancel-button checkout-cancel-button-outline"
            >
              Back to Home
            </button>
          </div>
        </div>
      </main>
    </div>
  );
};

export default CheckoutCancel;

